import { useEffect, useState } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { paths, industryPreset, type IndustryPreset, type IndustryVocab } from "@clevis/shared-types";
import { db } from "../lib/firebase";
import { useAuth } from "./useAuth";

// The tenant's industry preset — vocabulary ("Crew" vs "Techs", "Work
// tickets" vs "Jobs") and module defaults. Pre-presets tenants (industry
// null) read as "general", which keeps today's wording everywhere.
export function useIndustry(): {
  industry: string | null;
  preset: IndustryPreset;
  vocab: IndustryVocab;
  /** Owner shared the email-intake queue with managers. */
  intakeShared: boolean;
} {
  const { tenantId } = useAuth();
  const [industry, setIndustry] = useState<string | null>(null);
  const [intakeShared, setIntakeShared] = useState(false);

  useEffect(() => {
    if (!tenantId) return;
    return onSnapshot(doc(db, paths.tenant(tenantId)), (snap) => {
      setIndustry((snap.get("industry") as string | null) ?? null);
      setIntakeShared(snap.get("intakeShared") === true);
    });
  }, [tenantId]);

  const preset = industryPreset(industry);
  return { industry, preset, vocab: preset.vocab, intakeShared };
}
